const moveElementInArray = (array, oldIndex, newIndex) => {
    let tmpNewIndex = newIndex;

    if (tmpNewIndex < 0) {
        tmpNewIndex = 0;
    } else if (tmpNewIndex >= array.length) {
        tmpNewIndex = array.length;
    }

    const arrayClone = array.slice();
    const value = arrayClone.splice(oldIndex, 1);
    arrayClone.splice(tmpNewIndex, 0, ...value);

    return arrayClone;
};

export { moveElementInArray };
